export const UI_PORT = 3007;
export const CONTEXT_PATH = '/console';
export const API_PATH = ' ';
export const API_URL = API_PATH;
export const ENV_NAME = '';
export const STRIPE_PK = 'pk_live_51HtxPEGYFZZN9l0lwovfLDs4joziTz8EbRK4ZjVnSNxaItgMchCD7SPDiQ8LaQInR6Nos7VxAn7cS0jaficNCmFw00c3YEB6Uv';

export const BUILD_TAG = 'v1.4.17';

export const BUILD_DATE = 'Mon Apr 20 07:13:40 UTC 2026';

export const BUILD_COMMIT = 'ca4458da40a9987f019211197cd2f583b0332525';
